<template>
    <div>
        <div class="row">
            <div
                v-for="(parent, i) in optionsTree"
                :key="parent.id"
                class="mb-2"
                :class="getColClassSize(i)"
            >
                <NodeOption
                    v-model="optionsTree[i]"
                    :disabled="isDisabled"
                    @radio-input="parentRadioChange(optionsTree[i])"
                    @checkbox-input="parentCheckChange(optionsTree[i])"
                />
            </div>
        </div>
        <Error
            v-if="showError"
            class="mt-3"
            variant="no-border"
            :message="errorMessage"
        />
    </div>
</template>
  
<script>
import Error from 'custom-error';
import NodeOption from './NodeOption.vue';

export default {
    name: 'TreeOptions',
    components: {
        Error,
        NodeOption
    },
    props: {
        value: {
            type: Array,
            default: () => []
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        cols: {
            type: Number,
            default: 1
        },
        showError: {
            type: Boolean,
            default: false
        },
        errorMessage: {
            type: String,
            default: "Favor seleccionar al menos un criterio para completar el proceso."
        }
    },
    data: () => ({
        optionsTree: [],
    }),
    methods: {
        parentRadioChange(parent) {
            if (!parent.selected) return;
            
            this.optionsTree
                .filter(x => x.impedimentId == parent.impedimentId && parent.id != x.id)
                .forEach(option => {
                    const optionIndex = this.optionsTree.indexOf(option);
                    this.optionsTree[optionIndex].selected = false;

                    this.optionsTree[optionIndex].children.forEach(child => {
                        const childIndex = this.optionsTree[optionIndex].children.indexOf(child);
                        this.optionsTree[optionIndex].children[childIndex].selected = false
                    });
                });
        },
        parentCheckChange(parent) {
            const optionIndex = this.optionsTree.indexOf(parent);

            if (optionIndex < 0 || parent.selected) return;
            
            parent.children.forEach(child => {
                const childIndex = this.optionsTree[optionIndex].children.indexOf(child);
                this.optionsTree[optionIndex].children[childIndex].selected = false;
            });
        },
        getColClassSize(index) {
            switch (this.cols) {
            case 1:
                return 'col-12';
            case 2:
                return index % 2 == 0 ? 'col-3': 'col-9';
            }
        },
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.optionsTree = newValue;
            },
        },
        optionsTree: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    }
}
</script>